export default __webpack_public_path__ + "static/media/circle_1.86dd9436.svg";